export default {
  default: () => import("/Users/amin/Documents/Work/HHAA/Projects/game/telegram-mini-game-frontend/vue/layouts/default.vue").then(m => m.default || m)
}